import { Pipe, PipeTransform } from '@angular/core';

import _ from 'lodash';

import { Market } from '../models';

@Pipe({
    name: 'marketOverviewSupplierFilter',
    standalone: false
})
export class MarketOverviewSupplierFilterPipe implements PipeTransform {
	transform(markets: Market[], stateId: string, serviceTypeId: string, utilityId: string): { name: string; supplierId: string }[] {
		return _.chain(markets)
			.filter(m =>
				(!stateId || m.state.stateId === stateId) &&
				(!serviceTypeId || m.serviceType.serviceTypeId === serviceTypeId) &&
				(!utilityId || m.utility.utilityId === utilityId)
			)
			.map(m => m.supplier)
			.uniqBy(m => m.supplierId)
			.sortBy(m => m.name)
			.value();
	}
}
